import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
import Loading from './Loading';
import './LoadingTable.scss';

const LoadingTable = (props) => props.loading ? (
  <div className="nf-loadingTable">
    <Loading />
  </div>
) : null;

LoadingTable.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default LoadingTable;



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingTable.jsx